import React from "react";
import { ChevronDown, Users } from "lucide-react";

import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

import { ORDEM_TIPOS, TIPOS_CLIENTE } from "./tipos";

const rotulo = (filtro) => (!filtro ? "Qualquer cliente" : filtro === "exclusivas" ? "Só exclusivas" : `Valem p/ ${TIPOS_CLIENTE[filtro].nome}`);

/** Botão "Para quem vale" ao lado da busca das listas de ofertas (dono, 27/10/2026). */
export default function FiltroTipoCliente({ valor, aoMudar, e2e = "filtro-tipo-cliente" }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="gap-2" data-e2e={e2e}>
          <Users className="w-4 h-4" />
          {rotulo(valor)}
          <ChevronDown className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => aoMudar("")}>Qualquer cliente (todas)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => aoMudar("exclusivas")}>Só as exclusivas de algum tipo</DropdownMenuItem>
        <DropdownMenuSeparator />
        {ORDEM_TIPOS.map((k) => (
          <DropdownMenuItem key={k} onClick={() => aoMudar(k)}>Valem para {TIPOS_CLIENTE[k].nome}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
